import I18n from "common/i18n";
import Constants from "common/constant";

interface ChatHeaderProps {
  usageInfo?: {
    remaining: number;
    limit: number;
  } | null;
}

export const ChatHeader = ({ usageInfo }: ChatHeaderProps) => {
  return (
    <div className="flex flex-row items-center gap-4 px-6 py-4 bg-[#e0f7fa] h-[80px] overflow-hidden">
      {/* AIアバター */}
      <img
        src={`${Constants.assetHost}/assets/images/little_pal.png`}
        className="h-full w-auto object-contain flex-shrink-0"
      />

      {/* AI情報 */}
      <div className="flex flex-col gap-[2px] flex-1">
        <div className="text-[28px] text-[#1b775c] drop-shadow-[1px_1px_2px_rgba(0,0,0,0.15)]">
          {I18n.t("MSG_ASSISTANT_NAME")}
        </div>
        <div className="text-[16px] text-[#1b775c] opacity-90">
          {I18n.t("MSG_ASSISTANT_STATUS")}
        </div>
      </div>

      {/* 利用回数表示 (FREEプランのみ) */}
      {usageInfo && (
        <div className="flex items-center px-3 py-1 bg-white/60 rounded-full">
          <span
            className={`text-[20px] ${
              usageInfo.remaining === 0 ? "text-red-100" : "text-[#1b775c]"
            }`}
          >
            {I18n.t("MSG_ASSISTANT_USAGE_COUNT", {
              remaining: usageInfo.remaining,
              limit: usageInfo.limit,
            })}
          </span>
        </div>
      )}
    </div>
  );
};
